export default __webpack_public_path__ + "static/media/gallery_00.6d3e14f2.jpg";